const DECLINE_CODE_MESSAGES: Record<string, string> = {
  do_not_honour: 'Your bank declined this payment. Please contact your bank or try a different card.',
  insufficient_funds: 'Your card has insufficient funds. Please use a different card.',
  card_velocity_exceeded: "You've exceeded your card's allowed transaction limit. Please try again later or use a different card.",
  generic_decline: 'Your card was declined. Please contact your bank or try a different card.',
  lost_card: 'Your card was declined. Please use a different payment method.',
  stolen_card: 'Your card was declined. Please use a different payment method.',
  fraudulent: 'Your card was declined. Please contact your bank or use a different card.',
  transaction_not_allowed: "This transaction isn't allowed on your card. Please contact your bank or use a different card.",
  try_again_later: 'A temporary issue prevented your payment. Please try again in a moment.',
  withdrawal_count_limit_exceeded: "You've reached your card's daily withdrawal limit. Please use a different card.",
  currency_not_supported: "Your card doesn't support payments in this currency. Please use a different card.",
  duplicate_transaction: 'A payment with the same amount was recently submitted. Please wait a moment before trying again.',
  card_not_supported: "Your card doesn't support this type of purchase. Please use a different card.",
  expired_card: 'Your card has expired. Please use a different card.',
  incorrect_cvc: "Your card's security code is incorrect. Please check and try again.",
  incorrect_number: 'The card number is incorrect. Please check and try again.',
};

export function formatStripeDeclineError(
  declineCode: string | undefined | null,
  fallbackMessage: string | undefined | null,
): string {
  if (declineCode && DECLINE_CODE_MESSAGES[declineCode]) {
    return DECLINE_CODE_MESSAGES[declineCode];
  }
  return fallbackMessage || 'Your payment could not be processed. Please try a different card.';
}
